// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
  'it-IT': {
    orderSummary: 'Riepilogo ordine',
    productsTotal: 'Totale prodotti',
    shippingFees: 'Spese di spedizione*',
    collectionFees: 'Spese di incasso',
    coupon: 'Buono',
    customFeesEstimate: 'Stima IVA',
    orderTotal: 'Totale ordine',
    includingVAT: 'IVA inclusa',
    excludingVAT: 'IVA esclusa',
    shippingFeesInfo:
      '* Le spese di spedizione sono calcolate in base alla nazione selezionata per il trasporto.',
    VATFeesInfo:
      "Per la UE L'IVA è compresa nel prezzo. Vale anche per alcuni stati extra UE (chiaramente indicato)",
    orderDetails: 'Dettagli ordine',
    oneItem: '1 articolo',
    moreThanOneItem: '{num} articoli',
    shippingHeading: 'Indirizzo',
    selectShippingMode: 'Seleziona modalità di consegna',
    shippingMode: {
      shipping: 'Spedizione',
      warehouse: 'Ritiro in sede',
      depot: 'Punto di ritiro',
    },
    shippingAddressHeading: 'Indirizzo di consegna',
    pleaseConfirmAddress: "Si prega di confermare l'indirizzo di consegna",
    selectCourier: 'Seleziona metodo di spedizione',
    noCourier:
      'Non sono state trovate opzioni di spedizione per la nazione selezionata. Contatta la nostra <a href="{link}">assistenza clienti</a>.',
    shippingCheckboxMustBeMarked:
      'Per proseguire è necessario spuntare la casella.',
    findNearestDepot: 'Trova il punto di ritiro più vicino',
    insertAddressOrZipCode: 'Inserisci un indirizzo',
    search: 'Cerca',
    selectDepot: 'Seleziona una sede',
    moreResults: 'Più risultati',
    warehouseAddress: 'Indirizzo',
    openingHours: 'Orari di apertura',
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
    },
    noWarehouseFound:
      'Per la nazione selezionata non è disponibile il ritiro in sede.',
    selectWarehouse: 'Seleziona una sede',
    proceedToPayment: 'Procedi al pagamento',
    paymentHeading: 'Pagamento',
    selectPayment: 'Seleziona metodo di pagamento',
    noPayment:
      'Non sono state trovate opzioni di pagamento per la nazione selezionata. Contatta la nostra <a href="{link}">assistenza clienti</a>.',
    billingAddressHeading: 'Indirizzo di fatturazione',
    billingAddressIsTheSameAsShippingAddress:
      'I miei dati per la consegna e la ricevuta di pagamento sono gli stessi',
    klarnaWarning:
      'Per procedere al pagamento con Klarna è necessario che la valuta sia impostata su {currency}.',
    klarnaWarningLink: 'Clicca qui per accettare la modifica',
    orderNotes: 'Note per {site} (NON verranno trasmesse al corriere)',
    orderNotesPlaceholder: 'Es. Esenzione IVA, messaggi personalizzati',
    insertCoupon: '',
    completePurchase: "Completa l'acquisto",
    confirmOrderHeading: 'Conferma ordine',
    confirmOrderNote:
      'Cliccando "Effettua l\'ordine", confermi di aver letto e accettato i <a href="{termsLink}">Termini & Condizioni</a> e la <a href="{privacyLink}">Politica sulla Privacy</a>.',
    placeOrder: "Effettua l'ordine",
  },
  'fr-FR': {
    orderSummary: 'Récapitulatif de la commande',
    productsTotal: 'Total des produits',
    shippingFees: 'Frais de livraison*',
    collectionFees: "Frais d'encaissement",
    coupon: "Bon d'achat",
    customFeesEstimate: 'Estimation TVA',
    orderTotal: 'Totale de la commande',
    includingVAT: 'TVA incluse',
    excludingVAT: 'TVA non incluse',
    shippingFeesInfo:
      '* Les frais de port sont calculés en fonction du Pays sélectionné pour le transport.',
    VATFeesInfo:
      "Pour les pays l'UE, la TVA est incluse dans le prix. Elle s'applique également à certains Pays non membres de l'UE (clairement indiqué).",
    orderDetails: 'Détails de la commande',
    oneItem: '1 article',
    moreThanOneItem: '{num} articles',
    shippingHeading: 'Adresse',
    selectShippingMode: 'Veuillez choisir le mode de livraison :',
    shippingMode: {
      shipping: 'Livraison',
      warehouse: 'Retrait dans notre magasin',
      depot: 'Point de relais',
    },
    shippingAddressHeading: 'Adresse de livraison',
    pleaseConfirmAddress: "Veuillez confirmer l'adresse de livraison",
    selectCourier: 'Veuillez sélectionner le mode de livraison',
    noCourier:
      'Aucune option de livraison n\'a été trouvée pour le pays sélectionné. Contactez notre <a href="{link}">assistance client</a>.',
    shippingCheckboxMustBeMarked:
      'Pour continuer, il est nécessaire de cocher la case.',
    findNearestDepot: 'Trouvez le point de relais le plus proche',
    insertAddressOrZipCode: 'Saisir une adresse',
    search: 'Rechercher',
    selectDepot: 'Sélectionner un site',
    moreResults: 'Plus de résultats',
    warehouseAddress: 'Adresse',
    openingHours: "Heures d'ouverture",
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
    noWarehouseFound:
      "Le retrait dans notre magasin n'est pas disponible pour le pays sélectionné.",
    selectWarehouse: 'Sélectionner un site',
    proceedToPayment: 'Procéder au paiement',
    paymentHeading: 'Paiement',
    selectPayment: 'Veuillez sélectionner le mode de paiement',
    noPayment:
      'Aucune option de paiement n\'a été trouvée pour le pays sélectionné. Contactez notre <a href="{link}">service client</a>.',
    billingAddressHeading: 'Adresse de facturation',
    billingAddressIsTheSameAsShippingAddress:
      'Mes coordonnées pour la livraison et la réception du paiement sont les mêmes',
    klarnaWarning:
      'Pour pouvoir effectuer votre paiement avec Klarna, il est nécessaire que la devise soit établie sur {currency}.',
    klarnaWarningLink: 'Cliquez ici pour accepter le changement',
    orderNotes: 'Notes pour {site} (ne seront PAS transmises au transporteur)',
    orderNotesPlaceholder: 'Ex. Exonération de la TVA, messages personnalisés',
    insertCoupon: '',
    completePurchase: "Finaliser l'achat",
    confirmOrderHeading: 'Confirmation de commande',
    confirmOrderNote:
      'En cliquant  « Passer la commande », vous confirmez d\'avoir lu et accepté les  <a href="{termsLink}">Termes et conditions</a> et la <a href="{privacyLink}">Politique de confidentialité</a>.',
    placeOrder: 'Passer la commande',
  },
  'es-ES': {
    orderSummary: 'Resumen del pedido',
    productsTotal: 'Total productos',
    shippingFees: 'Gastos de envío*',
    collectionFees: 'Gastos de gestión',
    coupon: 'Cupón',
    customFeesEstimate: 'Estimación IVA',
    orderTotal: 'Total pedido',
    includingVAT: 'IVA incluido',
    excludingVAT: 'IVA no incluido',
    shippingFeesInfo:
      '* Los gastos de envío se calculan según el país seleccionado para el transporte.',
    VATFeesInfo:
      'Para la UE, el IVA está incluido en el precio. También se aplica a algunos países no pertenecientes a la UE (se indica claramente)',
    orderDetails: 'Detalles pedido',
    oneItem: '1 artículo',
    moreThanOneItem: '{num} artículos',
    shippingHeading: 'Dirección',
    selectShippingMode: 'Seleccionar método de entrega',
    shippingMode: {
      shipping: 'Envío',
      warehouse: 'Recogida en sede',
      depot: 'Punto de recogida',
    },
    shippingAddressHeading: 'Dirección de entrega',
    pleaseConfirmAddress: 'Por favor, confirmar dirección de entrega',
    selectCourier: 'Seleccionar método de envío',
    noCourier:
      'No se han encontrado opciones de envío para el país seleccionado. Póngase en contacto con nuestro <a href="{link}">servicio de atención al cliente</a>.',
    shippingCheckboxMustBeMarked:
      'Para continuar, es necesario marcar la casilla.',
    findNearestDepot: 'Encuentra el punto de recogida más cercano',
    insertAddressOrZipCode: 'Introducir una dirección',
    search: 'Buscar',
    selectDepot: 'Seleccionar una ubicación',
    moreResults: 'Más resultados',
    warehouseAddress: 'Dirección',
    openingHours: 'Horario de apertura',
    days: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
    },
    noWarehouseFound:
      'La recogida en la sede no está disponible para el país seleccionado.',
    selectWarehouse: 'Seleccionar una sede',
    proceedToPayment: 'Proceder al pago',
    paymentHeading: 'Pago',
    selectPayment: 'Seleccionar método de pago',
    noPayment:
      'No se han encontrado opciones de pago para el país seleccionado. Póngase en contacto con nuestro <a href="{link}">servicio de atención al cliente</a>.',
    billingAddressHeading: 'Dirección de facturación',
    billingAddressIsTheSameAsShippingAddress:
      'Mis datos de entrega y recibo de pago son los mismos',
    klarnaWarning:
      'Para realizar un pago con Klarna, es necesario que la moneda esté configurada en {currency}.',
    klarnaWarningLink: 'Hacer clic aquí para aceptar el cambio',
    orderNotes: 'Notas para {site} (NO se transmitirán a la mensajería)',
    orderNotesPlaceholder: 'Ej: exención del IVA, mensajes personalizados',
    insertCoupon: '',
    completePurchase: 'Finalizar la compra',
    confirmOrderHeading: 'Confirmar el pedido',
    confirmOrderNote:
      'Al hacer clic en "Realizar el pedido", confirma que ha leído y aceptado los <a href="{termsLink}">Términos y condiciones</a> y la <a href="{privacyLink}">Política de privacidad</a>.',
    placeOrder: 'Realizar el pedido',
  },
  'en-GB': {
    orderSummary: 'Order summary',
    productsTotal: 'Products total',
    shippingFees: 'Shipping fees',
    collectionFees: 'Collection fees',
    coupon: 'Coupon',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: 'Including VAT',
    excludingVAT: 'Excluding VAT',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    orderDetails: 'Order details',
    oneItem: '1 item',
    moreThanOneItem: '{num} items',
    shippingHeading: 'Address',
    selectShippingMode: 'Select shipping mode',
    shippingMode: {
      shipping: 'Shipping',
      warehouse: 'Warehouse pickup',
      depot: 'Collection depot',
    },
    shippingAddressHeading: 'Delivery address',
    pleaseConfirmAddress: 'Please confirm delivery address',
    selectCourier: 'Select shipping method',
    noCourier:
      'No shipping options were found for the selected country. Contact our <a href="{link}">customer support</a>.',
    shippingCheckboxMustBeMarked:
      'To continue, it is necessary to tick the box.',
    findNearestDepot: 'Find your nearest collection depot',
    insertAddressOrZipCode: 'Insert an address',
    search: 'Search',
    selectDepot: 'Select depot',
    moreResults: 'More results',
    warehouseAddress: 'Address',
    openingHours: 'Opening hours',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    noWarehouseFound:
      'Warehouse pickup is not available for the selected country.',
    selectWarehouse: 'Select warehouse',
    proceedToPayment: 'Proceed to payment',
    paymentHeading: 'Payment',
    selectPayment: 'Select payment method',
    noPayment:
      'No payment options were found for the selected country. Contact our <a href="{link}">customer service</a>.',
    billingAddressHeading: 'Billing address',
    billingAddressIsTheSameAsShippingAddress:
      'My billing and delivery information is the same',
    klarnaWarning:
      'In order to pay with Klarna, the currency must be set to {currency}.',
    klarnaWarningLink: 'Click here to accept the change',
    orderNotes: 'Notes for {site} (will NOT be forwarded to the courier)',
    orderNotesPlaceholder: 'E.g. VAT exemption, customized messages',
    insertCoupon: '',
    completePurchase: 'Complete purchase',
    confirmOrderHeading: 'Confirm order',
    confirmOrderNote:
      'Clicking "Place order", you confirm that you have read and agree to the <a href="{termsLink}">Terms & Conditions</a> and <a href="{privacyLink}">Privacy Policy</a>.',
    placeOrder: 'Place order',
  },
  'en-US': {
    orderSummary: 'Order summary',
    productsTotal: 'Products total',
    shippingFees: 'Shipping fees',
    collectionFees: 'Collection fees',
    coupon: 'Coupon',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: 'Including VAT',
    excludingVAT: 'Excluding VAT',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    orderDetails: 'Order details',
    oneItem: '1 item',
    moreThanOneItem: '{num} items',
    shippingHeading: 'Address',
    selectShippingMode: 'Select shipping mode',
    shippingMode: {
      shipping: 'Shipping',
      warehouse: 'Warehouse pickup',
      depot: 'Collection depot',
    },
    shippingAddressHeading: 'Delivery address',
    pleaseConfirmAddress: 'Please confirm delivery address',
    selectCourier: 'Select shipping method',
    noCourier:
      'No shipping options were found for the selected country. Contact our <a href="{link}">customer support</a>.',
    shippingCheckboxMustBeMarked:
      'To continue, it is necessary to tick the box.',
    findNearestDepot: 'Find your nearest collection depot',
    insertAddressOrZipCode: 'Insert an address',
    search: 'Search',
    selectDepot: 'Select depot',
    moreResults: 'More results',
    warehouseAddress: 'Address',
    openingHours: 'Opening hours',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    noWarehouseFound:
      'Warehouse pickup is not available for the selected country.',
    selectWarehouse: 'Select warehouse',
    proceedToPayment: 'Proceed to payment',
    paymentHeading: 'Payment',
    selectPayment: 'Select payment method',
    noPayment:
      'No payment options were found for the selected country. Contact our <a href="{link}">customer service</a>.',
    billingAddressHeading: 'Billing address',
    billingAddressIsTheSameAsShippingAddress:
      'My billing and delivery information is the same',
    klarnaWarning:
      'In order to pay with Klarna, the currency must be set to {currency}.',
    klarnaWarningLink: 'Click here to accept the change',
    orderNotes: 'Notes for {site} (will NOT be forwarded to the courier)',
    orderNotesPlaceholder: 'E.g. VAT exemption, customized messages',
    insertCoupon: '',
    completePurchase: 'Complete purchase',
    confirmOrderHeading: 'Confirm order',
    confirmOrderNote:
      'Clicking "Place order", you confirm that you have read and agree to the <a href="{termsLink}">Terms & Conditions</a> and <a href="{privacyLink}">Privacy Policy</a>.',
    placeOrder: 'Place order',
  },
  'de-DE': {
    orderSummary: 'Zusammenfassung der Bestellung',
    productsTotal: 'Produkte insgesamt',
    shippingFees: 'Versandgebühren*',
    collectionFees: 'Einzugsgebühren',
    coupon: 'Rabatt',
    customFeesEstimate: 'Schätzung MwSt./USt.',
    orderTotal: 'Bestellung gesamt',
    includingVAT: 'Inklusive MwSt.',
    notIncludingVAT: 'Ohne MwSt.',
    shippingFeesInfo:
      '*Die Versandgebühren werden je nach gewähltem Zielland berechnet.',
    VATFeesInfo:
      'Für EU-Länder ist die Mehrwertsteuer im Preis enthalten. Gilt auch für einige Nicht-EU-Länder (deutlich gekennzeichnet)',
    orderDetails: 'Details der Bestellung',
    oneItem: '1 Artikel',
    moreThanOneItem: '{num} Artikel',
    shippingHeading: 'Adresse',
    selectShippingMode: 'Versandart auswählen',
    shippingMode: {
      shipping: 'Versand',
      warehouse: 'Abholung am Lager',
      depot: 'Abholdepot',
    },
    shippingAddressHeading: 'Lieferadresse',
    pleaseConfirmAddress: 'Bitte bestätigen Sie die Lieferadresse',
    selectCourier: 'Versandart wählen',
    noCourier:
      'Für das ausgewählte Land wurden keine Versandoptionen gefunden. Kontaktieren Sie unseren <a href="{link}">Kundenservice</a>.',
    shippingCheckboxMustBeMarked:
      'Um fortzufahren, müssen Sie das Kästchen ankreuzen.',
    findNearestDepot: 'Finden Sie Ihr nächstgelegenes Abholdepot',
    insertAddressOrZipCode: 'Eine Adresse eingeben',
    search: 'Suche',
    selectDepot: 'Depot auswählen',
    moreResults: 'Mehr Ergebnisse',
    warehouseAddress: 'Adresse',
    openingHours: 'Öffnungszeiten',
    days: {
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
    },
    noWarehouseFound:
      'Die Abholung im Lager ist für das ausgewählte Land nicht möglich.',
    selectWarehouse: 'Lager auswählen',
    proceedToPayment: 'Weiter zur Zahlung',
    paymentHeading: 'Bezahlung',
    selectPayment: 'Zahlungsmethode auswählen',
    noPayment:
      'Für das ausgewählte Land wurden keine Zahlungsoptionen gefunden. Kontaktieren Sie unseren <a href="{link}">Kundendienst</a>.',
    billingAddressHeading: 'Rechnungsadresse',
    billingAddressIsTheSameAsShippingAddress:
      'Meine Rechnungs- und Lieferinformationen sind identisch',
    klarnaWarning:
      'Um mit der Zahlung mit Klarna fortzufahren, müssen Sie die Währung auf {currency} einstellen.',
    klarnaWarningLink: 'Klicken Sie hiere, um die Änderung zu akzeptieren',
    orderNotes: 'Notizen für {site} (Wird NICHT an den Kurier weitergeleitet)',
    orderNotesPlaceholder:
      'Z.B. Mehrwertsteuerbefreiung, individuelle Nachrichten',
    insertCoupon: '',
    completePurchase: 'Kauf abschließen',
    confirmOrderHeading: 'Bestätigen Sie die Bestellung',
    confirmOrderNote:
      'Wenn Sie auf "Bestellung bestätigen" klicken, bestätigen Sie, dass Sie die <a href="{termsLink}">Nutzungsbedingungen</a> und <a href="{privacyLink}">Datenschutzbestimmungen</a> gelesen haben und damit einverstanden sind.',
    placeOrder: 'Bestellung tätigen',
  },
  'en-AU': {
    orderSummary: 'Order summary',
    productsTotal: 'Products total',
    shippingFees: 'Shipping fees',
    collectionFees: 'Collection fees',
    coupon: 'Coupon',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: 'Including VAT',
    excludingVAT: 'Excluding VAT',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    orderDetails: 'Order details',
    oneItem: '1 item',
    moreThanOneItem: '{num} items',
    shippingHeading: 'Address',
    selectShippingMode: 'Select shipping mode',
    shippingMode: {
      shipping: 'Shipping',
      warehouse: 'Warehouse pickup',
      depot: 'Collection depot',
    },
    shippingAddressHeading: 'Delivery address',
    pleaseConfirmAddress: 'Please confirm delivery address',
    selectCourier: 'Select shipping method',
    noCourier:
      'No shipping options were found for the selected country. Contact our <a href="{link}">customer support</a>.',
    shippingCheckboxMustBeMarked:
      'To continue, it is necessary to tick the box.',
    findNearestDepot: 'Find your nearest collection depot',
    insertAddressOrZipCode: 'Insert an address',
    search: 'Search',
    selectDepot: 'Select depot',
    moreResults: 'More results',
    warehouseAddress: 'Address',
    openingHours: 'Opening hours',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    noWarehouseFound:
      'Warehouse pickup is not available for the selected country.',
    selectWarehouse: 'Select warehouse',
    proceedToPayment: 'Proceed to payment',
    paymentHeading: 'Payment',
    selectPayment: 'Select payment method',
    noPayment:
      'No payment options were found for the selected country. Contact our <a href="{link}">customer service</a>.',
    billingAddressHeading: 'Billing address',
    billingAddressIsTheSameAsShippingAddress:
      'My billing and delivery information is the same',
    klarnaWarning:
      'In order to pay with Klarna, the currency must be set to {currency}.',
    klarnaWarningLink: 'Click here to accept the change',
    orderNotes: 'Notes for {site} (will NOT be forwarded to the courier)',
    orderNotesPlaceholder: 'E.g. VAT exemption, customized messages',
    insertCoupon: '',
    completePurchase: 'Complete purchase',
    confirmOrderHeading: 'Confirm order',
    confirmOrderNote:
      'Clicking "Place order", you confirm that you have read and agree to the <a href="{termsLink}">Terms & Conditions</a> and <a href="{privacyLink}">Privacy Policy</a>.',
    placeOrder: 'Place order',
  },
  'ko-KR': {
    orderSummary: 'Order summary',
    productsTotal: 'Products total',
    shippingFees: 'Shipping fees',
    collectionFees: 'Collection fees',
    coupon: 'Coupon',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: 'Including VAT',
    excludingVAT: 'Excluding VAT',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    orderDetails: 'Order details',
    oneItem: '1 item',
    moreThanOneItem: '{num} items',
    shippingHeading: 'Address',
    selectShippingMode: 'Select shipping mode',
    shippingMode: {
      shipping: 'Shipping',
      warehouse: 'Warehouse pickup',
      depot: 'Collection depot',
    },
    shippingAddressHeading: 'Delivery address',
    pleaseConfirmAddress: 'Please confirm delivery address',
    selectCourier: 'Select shipping method',
    noCourier:
      'No shipping options were found for the selected country. Contact our <a href="{link}">customer support</a>.',
    shippingCheckboxMustBeMarked:
      'To continue, it is necessary to tick the box.',
    findNearestDepot: 'Find your nearest collection depot',
    insertAddressOrZipCode: 'Insert an address',
    search: 'Search',
    selectDepot: 'Select depot',
    moreResults: 'More results',
    warehouseAddress: 'Address',
    openingHours: 'Opening hours',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    noWarehouseFound:
      'Warehouse pickup is not available for the selected country.',
    selectWarehouse: 'Select warehouse',
    proceedToPayment: 'Proceed to payment',
    paymentHeading: 'Payment',
    selectPayment: 'Select payment method',
    noPayment:
      'No payment options were found for the selected country. Contact our <a href="{link}">customer service</a>.',
    billingAddressHeading: 'Billing address',
    billingAddressIsTheSameAsShippingAddress:
      'My billing and delivery information is the same',
    klarnaWarning:
      'In order to pay with Klarna, the currency must be set to {currency}.',
    klarnaWarningLink: 'Click here to accept the change',
    orderNotes: 'Notes for {site} (will NOT be forwarded to the courier)',
    orderNotesPlaceholder: 'E.g. VAT exemption, customized messages',
    insertCoupon: '',
    completePurchase: 'Complete purchase',
    confirmOrderHeading: 'Confirm order',
    confirmOrderNote:
      'Clicking "Place order", you confirm that you have read and agree to the <a href="{termsLink}">Terms & Conditions</a> and <a href="{privacyLink}">Privacy Policy</a>.',
    placeOrder: 'Place order',
  },
  'jp-JP': {
    orderSummary: 'Order summary',
    productsTotal: 'Products total',
    shippingFees: 'Shipping fees',
    collectionFees: 'Collection fees',
    coupon: 'Coupon',
    customFeesEstimate: 'VAT estimate',
    orderTotal: 'Order total',
    includingVAT: 'Including VAT',
    excludingVAT: 'Excluding VAT',
    shippingFeesInfo:
      '* Shipping fees are calculated according to the country selected for shipping.',
    VATFeesInfo:
      'For EU countries VAT is included in the price. Also applies to some non-EU countries (clearly indicated)',
    orderDetails: 'Order details',
    oneItem: '1 item',
    moreThanOneItem: '{num} items',
    shippingHeading: 'Address',
    selectShippingMode: 'Select shipping mode',
    shippingMode: {
      shipping: 'Shipping',
      warehouse: 'Warehouse pickup',
      depot: 'Collection depot',
    },
    shippingAddressHeading: 'Delivery address',
    pleaseConfirmAddress: 'Please confirm delivery address',
    selectCourier: 'Select shipping method',
    noCourier:
      'No shipping options were found for the selected country. Contact our <a href="{link}">customer support</a>.',
    shippingCheckboxMustBeMarked:
      'To continue, it is necessary to tick the box.',
    findNearestDepot: 'Find your nearest collection depot',
    insertAddressOrZipCode: 'Insert an address',
    search: 'Search',
    selectDepot: 'Select depot',
    moreResults: 'More results',
    warehouseAddress: 'Address',
    openingHours: 'Opening hours',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    noWarehouseFound:
      'Warehouse pickup is not available for the selected country.',
    selectWarehouse: 'Select warehouse',
    proceedToPayment: 'Proceed to payment',
    paymentHeading: 'Payment',
    selectPayment: 'Select payment method',
    noPayment:
      'No payment options were found for the selected country. Contact our <a href="{link}">customer service</a>.',
    billingAddressHeading: 'Billing address',
    billingAddressIsTheSameAsShippingAddress:
      'My billing and delivery information is the same',
    klarnaWarning:
      'In order to pay with Klarna, the currency must be set to {currency}.',
    klarnaWarningLink: 'Click here to accept the change',
    orderNotes: 'Notes for {site} (will NOT be forwarded to the courier)',
    orderNotesPlaceholder: 'E.g. VAT exemption, customized messages',
    insertCoupon: '',
    completePurchase: 'Complete purchase',
    confirmOrderHeading: 'Confirm order',
    confirmOrderNote:
      'Clicking "Place order", you confirm that you have read and agree to the <a href="{termsLink}">Terms & Conditions</a> and <a href="{privacyLink}">Privacy Policy</a>.',
    placeOrder: 'Place order',
  },
};
